(ns dre.app.router
  (:require
   [bidi.bidi :as bidi]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.pages.events :as-alias pages]
   [lambdaisland.uri :refer [query-map map->query-string]]
   [pushy.core :as pushy]
   [re-frame.core :as rf]))


(defonce history (atom nil))


(def admin-routes
  ["admin"
   [["" :admin]
    ["/"
     [["" :admin]
      ["help"
       [["" :admin-help]
        ["/" :admin-help]]]
      ["feed"
       [["" :admin-feed
         "/" :admin-feed]]]
      ["survey"
       [["" :admin-survey
         "/" :admin-survey]]]
      ["usage"
       [["" :admin-usage]
        ["/" :admin-usage]]]
      ["client-download"
       [["" :admin-client-download]
        ["/" :admin-client-download]]]
      ["ai-summarization-usage"
       [["" :admin-ai-summarization-usage]
        ["/" :admin-ai-summarization-usage]]]]]]])


(def not-found-route
  [true :not-found])


(def routes
  ["/"
   (conj [["" :frontpage]
          ["search" :search]
          [["details/" :id] :detail]
          ["annotator" :annotator]
          ["saved"
           [["" :my-searches]
            ["/"
             [["" :my-searches]
              ["saved-searches"
               [["" :signals]
                ["/" :signals]]]
              ["tags"
               [["" :tags
                 "/" :tags]]]
              ["search-history"
               [["" :search-history
                 "/" :search-history]]]]]]]
          ["shared" :shared]
          [["dictionary/" :guid] :dictionary]
          ["help" :help]
          ["videos" :videos]
          ["pubmed-compare" :pubmed-compare]]
         admin-routes
         not-found-route)])

(def ->route (partial bidi/path-for routes))

(defn ->route-with-query-params 
  [route query-params]
  (str route "?" (map->query-string query-params)))

(defonce page-transition
  (if js/document.startViewTransition
    (fn [callback]
      (js/document.startViewTransition callback))
    (fn [callback]
      (callback))))


(defn- dispatch
  [route]
  (page-transition #(rf/dispatch [::pages/set-page route])))


(defn- match
  [url]
  (let [query-params (query-map url {:into (hash-map)})]
    (-> (bidi/match-route routes url)
        (assoc :query-params query-params))))

(defn current-path
  []
  (pushy/get-token @history))

(defn current-route
  []
  (:handler (bidi/match-route routes (pushy/get-token @history))))

(defn start!
  []
  (let [history' (pushy/pushy dispatch match
                              :prevent-default-when-no-match? (constantly true))]
    (reset! history history')
    (pushy/start! history')))


(rf/reg-fx
  ::init
  (fn [_]
    (start!)))


(rf/reg-event-fx
  ::init
  (fn [_ _]
    {::init nil}))


(rf/reg-fx
  ::redirect-to-path
  (fn [path]
    (pushy/set-token! @history path)))

(rf/reg-event-fx
 ::redirect-to-path
 [rf/trim-v]
 (fn-traced [_ [path]]
            {::redirect-to-path path}))

(rf/reg-event-fx
 ::redirect-to-path-with-query-params
 [rf/trim-v]
 (fn-traced [_ [path query-params]]
            (let [new-path (str path "?" (map->query-string query-params))]
              {::redirect-to-path new-path})))


(rf/reg-fx
  ::redirect-to-handler
  (fn [handler]
    (->>
      handler
      (bidi/path-for routes)
      (pushy/set-token! @history))))


(rf/reg-event-fx
  ::redirect-to-handler
  [rf/trim-v]
  (fn-traced [_ [handler]]
             {::redirect-to-handler handler}))


(rf/reg-fx
 ::redirect-to-handler-with-query-params
 (fn [[handler query-params]]
   (pushy/set-token! @history (str (->>
                                    handler
                                    (bidi/path-for routes)) "?" (map->query-string query-params)))))

(rf/reg-event-fx
 ::redirect-to-handler-with-query-params
 [rf/trim-v]
 (fn-traced [_ [handler query-params]]
            {::redirect-to-handler-with-query-params [handler query-params]}))

